import { appConfig } from '@planner/config';
/**
 * Unambiguous alphabet (no 0/O, 1/I/L) so codes survive being read over the
 * phone or written on a Bunnings special-order form.
 */
const ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
const CODE_LENGTH = 6;
export function generateReferenceCode(prefix = appConfig.referencePrefix) {
    let code = '';
    const values = new Uint32Array(CODE_LENGTH);
    // globalThis.crypto exists in both Node >= 19 and browsers; the cast avoids
    // needing DOM/Node type libs in this platform-neutral package.
    const webCrypto = globalThis.crypto;
    webCrypto.getRandomValues(values);
    for (const value of values) {
        code += ALPHABET[value % ALPHABET.length];
    }
    return `${prefix}-${code}`;
}
export function isValidReferenceCode(value, prefix = appConfig.referencePrefix) {
    const pattern = new RegExp(`^${prefix}-[${ALPHABET}]{${CODE_LENGTH}}$`);
    return pattern.test(value);
}
//# sourceMappingURL=reference.js.map